"use strict";

(() => {
  // ブレイクポイント(1024px)以上で発火
  const BREAKPOINT = 1024;
  const ACTIVE_CLASS = "is-active";
  const TRIGGER_SELECTOR =
    "[data-sticky-scroll-target], .js-stickyScrollTrigger, .js-interviewImageTrigger";
  const TARGET_SELECTOR = "[data-sticky-scroll], .js-stickyScrollTarget, .js-interviewImageTarget";

  const mediaQuery = window.matchMedia ? window.matchMedia(`(min-width: ${BREAKPOINT}px)`) : null;

  let observer = null;

  const getKeyFromTrigger = (el) =>
    el?.dataset?.stickyScrollTarget ?? el?.dataset?.imageTarget ?? el?.dataset?.target ?? "";

  const getKeyFromTarget = (el) =>
    el?.dataset?.stickyScroll ?? el?.dataset?.image ?? el?.dataset?.target ?? "";

  const setActive = (key, targets) => {
    if (!key) return;
    targets.forEach((target) => {
      const targetKey = getKeyFromTarget(target);
      if (!targetKey) return;
      target.classList.toggle(ACTIVE_CLASS, targetKey === key);
    });
  };

  const destroyObserver = () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  };

  const initObserver = () => {
    const triggers = Array.from(document.querySelectorAll(TRIGGER_SELECTOR));
    const targets = Array.from(document.querySelectorAll(TARGET_SELECTOR));

    if (!mediaQuery?.matches || !triggers.length || !targets.length) {
      return;
    }

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const key = getKeyFromTrigger(entry.target);
          if (key) setActive(key, targets);
        });
      },
      {
        rootMargin: "-35% 0% -45% 0%",
        threshold: 0,
      }
    );

    triggers.forEach((trigger) => observer.observe(trigger));

    const initialKey =
      getKeyFromTrigger(
        triggers.find((trigger) => trigger.classList.contains(ACTIVE_CLASS)) ?? triggers[0]
      ) ?? "";

    if (initialKey) setActive(initialKey, targets);
  };

  const handleMediaChange = () => {
    destroyObserver();

    if (!mediaQuery || !mediaQuery.matches) {
      document.querySelectorAll(TARGET_SELECTOR).forEach((target) => {
        target.classList.add(ACTIVE_CLASS);
      });
      return;
    }

    initObserver();
  };

  window.addEventListener("load", () => {
    handleMediaChange();

    if (!mediaQuery) return;

    if ("addEventListener" in mediaQuery) {
      mediaQuery.addEventListener("change", handleMediaChange);
    } else if ("addListener" in mediaQuery) {
      mediaQuery.addListener(handleMediaChange);
    }
  });
})();
